import type { ProviderDriverKind, ProviderInstanceId, ServerProvider } from "@heydex/contracts";
import { resolveSelectableModel } from "@heydex/shared/model";

import { deriveProviderInstanceEntries } from "./providerInstances";
import { getDefaultServerModel, resolveSelectableProvider } from "./providerModels";

export function resolveAppModelSelection(
  provider: ProviderDriverKind,
  providers: ReadonlyArray<ServerProvider>,
  selectedModel: string | null | undefined,
): string {
  const resolvedProvider = resolveSelectableProvider(providers, provider);
  const models = providers.find((candidate) => candidate.driver === resolvedProvider)?.models ?? [];
  return (
    resolveSelectableModel(selectedModel, models) ??
    getDefaultServerModel(providers, resolvedProvider)
  );
}

export function resolveAppModelSelectionForInstance(
  instanceId: ProviderInstanceId,
  providers: ReadonlyArray<ServerProvider>,
  selectedModel: string | null | undefined,
): string | null {
  const entry = deriveProviderInstanceEntries(providers).find(
    (candidate) => candidate.instanceId === instanceId,
  );
  if (!entry) return null;
  return resolveSelectableModel(selectedModel, entry.models) ?? entry.models[0]?.slug ?? null;
}
